import { Box, Heading } from "theme-ui";
import { SiGatsby } from "react-icons/si";
import * as React from 'react';
export default {
  Box,
  Heading,
  SiGatsby,
  React
};